import styled from 'styled-components';
import { FontWeight, device, spacing } from 'commons';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

const { borderRadius, height } = spacing.input;

export const Wrapper = styled.div`
  position: relative;
`;

export const Overlay = styled.button<{ $isOpen?: boolean }>`
  display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
  opacity: 0;
  position: 'fixed';
  width: '100%';
  height: '100%';
  top: 0;
  left: 0;
  z-index: 9;
`;

export const SelectedPeriod = styled.div<{
  $danger?: boolean;
}>`
  padding-bottom: 16px;

  ${({ $danger, theme }) => $danger && `color: ${theme.danger_500}`}
`;

export const DateRangePickerWrapper = styled.div`
  width: fit-content;
  position: absolute;
  top: ${height};
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.neutral_100};
  padding: 24px;
  box-shadow: 0px 16px 32px 0px #00000014;
  border-radius: ${borderRadius};
  z-index: 10;

  @media screen and (max-width: ${device.mobile}px) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: scroll;
    justify-content: space-evenly;
    transform: unset !important;
  }
`;

export const DateRangeWarning = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;

  strong {
    font-weight: ${FontWeight.bold};
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    fill: ${({ theme }) => theme.warning_500};
  }
`;

export const CloseButton = styled.button`
  align-self: flex-start;
  background: none;
  border: none;
`;

export const DateRangePickerContent = styled.div`
  display: flex;

  @media (max-width: ${device.mobile}px) {
    .rdrMonthsVertical {
      height: auto;
    }
    .rdrCalendarWrapper {
      width: 100%;

      .rdrMonths {
        justify-content: center;
        align-items: center;
      }
    }
  }

  @media (min-width: ${device.mobile}px) and (max-width: ${device.desktopSmall}px) {
    .rdrMonthsVertical {
      overflow: auto;
      height: 300px;
    }
    .rdrMonth {
      width: 260px;
    }
  }
`;

export const DateRangeActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 26px;
`;

export const ResetButton = styled.button`
  color: ${({ theme }) => theme.neutral_700};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  text-decoration: underline;
  background-color: transparent;
  font-weight: 700;
  cursor: pointer;

  svg {
    fill: ${({ theme }) => theme.neutral_700};
    transform: rotate(45deg);
  }
`;
